import { Controller } from "@hotwired/stimulus"
import i18n from "../javascripts/util/i18n"

export default class extends Controller {
  static targets = ["dialog", "title", "message", "icon", "confirmBtn", "form"]

  open(event) {
    event.preventDefault()
    event.stopPropagation()

    const trigger = event.currentTarget
    const title = trigger.dataset.confirmTitle || i18n.t("js.common.confirm")
    const message = trigger.dataset.confirmMessage || i18n.t("js.common.are_you_sure")
    const variant = trigger.dataset.confirmVariant || "default"
    const confirmLabel = trigger.dataset.confirmLabel || i18n.t("js.common.confirm")
    const action = trigger.dataset.confirmAction
    const method = trigger.dataset.confirmMethod || "post"

    this.titleTarget.textContent = title
    this.messageTarget.textContent = message
    this.confirmBtnTarget.textContent = confirmLabel

    this.formTarget.action = action
    const methodInput = this.formTarget.querySelector("input[name='_method']")
    if (methodInput) {
      methodInput.value = method
    }

    this.applyVariant(variant)

    this.submitting = false
    this.confirmBtnTarget.disabled = false

    if (this.dialogTarget.showModal) {
      this.dialogTarget.showModal()
    } else {
      this.dialogTarget.setAttribute("open", "open")
    }
  }

  close() {
    if (this.dialogTarget.close) {
      this.dialogTarget.close()
    } else {
      this.dialogTarget.removeAttribute("open")
    }
  }

  confirm() {
    if (this.submitting) return
    this.submitting = true
    this.confirmBtnTarget.disabled = true
    this.confirmBtnTarget.classList.add("opacity-70", "cursor-not-allowed")
    this.formTarget.requestSubmit()
  }

  backdropClick(event) {
    if (event.target === this.dialogTarget) {
      this.close()
    }
  }

  applyVariant(variant) {
    const btn = this.confirmBtnTarget
    const icon = this.iconTarget

    btn.className = "flex-1 inline-flex items-center justify-center rounded-lg px-4 py-2.5 text-sm font-semibold shadow-theme-xs transition-colors focus:outline-none focus:ring-2"

    switch (variant) {
      case "danger":
        btn.classList.add("bg-red-600", "text-white", "hover:bg-red-700", "focus:ring-red-200")
        icon.innerHTML = this.dangerIcon()
        icon.className = "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-red-50 dark:bg-red-500/10"
        break
      case "success":
        btn.classList.add("bg-emerald-500", "text-white", "hover:bg-emerald-600", "focus:ring-emerald-200")
        icon.innerHTML = this.successIcon()
        icon.className = "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-emerald-50 dark:bg-emerald-500/10"
        break
      default:
        btn.classList.add("bg-brand-500", "text-white", "hover:bg-brand-600", "focus:ring-brand-200")
        icon.innerHTML = this.infoIcon()
        icon.className = "mx-auto flex h-12 w-12 items-center justify-center rounded-full bg-brand-50 dark:bg-brand-500/10"
        break
    }
  }

  dangerIcon() {
    return `<i class="fa-solid fa-triangle-exclamation text-2xl text-red-600 dark:text-red-400"></i>`
  }

  successIcon() {
    return `<i class="fa-solid fa-circle-check text-2xl text-emerald-600 dark:text-emerald-400"></i>`
  }

  infoIcon() {
    return `<i class="fa-solid fa-circle-info text-2xl text-brand-600 dark:text-brand-400"></i>`
  }
}
